// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-19a7510e]{background:red 0 0 no-repeat padding-box;box-shadow:0 3px 6px rgba(0,0,0,.1607843137254902);border-radius:5px;opacity:1}.card__message[data-v-19a7510e]{text-align:left;font:normal normal 700 24px/32px Segoe UI;letter-spacing:0;color:#fff!important;opacity:1;white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
